import CoreButton from 'client/components/core/BlueButton'
import { createCarouselItem } from 'client/components/entities/Carousel'
import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import CarouselInterface from 'common/types/entities/CarouselInterface'
import { Appearance } from 'common/types/entities/EntityInterface'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { CheckboxControl } from 'src/editor/shared/settings/checkbox-control'
import { ColorPickerControl } from 'src/editor/shared/settings/controls/color-picker/color-picker-control'
import { SizeAndPositionGroup } from 'src/editor/shared/settings/groups/size-and-position'
import EntityInnerItems from '../../components/EntityInnerItems'
import { useUpdateEntity, useUpdateProp } from '../../hooks/useUpdateProps'
import DeviceAppearance from '../../options/DeviceAppearance/DeviceAppearance'
import HtmlAttrId from '../../options/HtmlAttrId'
import VerticalAlign from '../../styles/VerticalAlign'

type CarouselSettingsProps = {
  entity: CarouselInterface
}

function CarouselSettings({ entity }: CarouselSettingsProps) {
  const updateProp = useUpdateProp(entity)
  const updateEntity = useUpdateEntity<CarouselInterface>()
  const { isMobile } = useDeviceModeContext()
  const { t } = useTranslation()

  function updateAppearance(appearance: Appearance) {
    updateEntity({
      ...entity,
      appearance,
    })
  }

  return (
    <>
      <EntityInnerItems
        entity={entity}
        createEntityInnerItem={createCarouselItem}
        addItemButtonText="entity_settings.carousel.item.add"
        removeWarningText="entity_settings.carousel.remove_item_warning"
        renderInnerItem={(innerItem, switchToItem, isActive) => (
          <CoreButton
            onClick={switchToItem}
            // @ts-ignore
            styles={{
              marginRight: 'auto',
              ...(!isActive ? { background: '#bcbcbc' } : {}),
            }}
          >
            {t('entity_settings.carousel.item_number', {
              itemNumber: innerItem.creationItemNumber,
            })}
          </CoreButton>
        )}
      />
      <VerticalAlign
        label={'entity_settings.carousel.item_vertical_align.title'}
        align={
          isMobile ? entity.mobileVerticalAlignment : entity.verticalAlignment
        }
        update={updateProp(
          isMobile ? 'mobileVerticalAlignment' : 'verticalAlignment',
        )}
      />
      {/*@ts-ignore*/}
      <CheckboxControl
        label="entity_settings.carousel.show_arrows.label"
        update={updateProp('showArrows')}
        mobileUpdate={updateProp('mobileShowArrows')}
        value={entity.showArrows}
        mobileValue={entity.mobileShowArrows}
      />
      <ColorPickerControl
        update={updateProp('controlsColor')}
        color={entity.controlsColor}
        label="entity_settings.carousel.controls_color.label"
        singleColorMode
      />
      <ColorPickerControl
        update={updateProp('arrowsColor')}
        color={entity.arrowsColor}
        label="entity_settings.carousel.arrows_color.label"
        singleColorMode
      />
      <SizeAndPositionGroup
        padding={isMobile ? entity?.mobilePadding : entity.padding}
        updatePadding={updateProp(isMobile ? 'mobilePadding' : 'padding')}
        margin={isMobile ? entity.mobileMargin : entity.margin}
        updateMargin={updateProp(isMobile ? 'mobileMargin' : 'margin')}
      />
      <DeviceAppearance
        update={updateAppearance}
        desktop={entity.appearance.desktop}
        mobile={entity.appearance.mobile}
      />
      <HtmlAttrId attrId={entity.htmlAttrId} />
    </>
  )
}

export default CarouselSettings
